module.exports = __webpack_public_path__ + "static/princeton-e68cf4111addc16f3c3f66af6577e515.png";